<router-outlet></router-outlet>
<p-toast key="globalToast" position="bottom-right"></p-toast>
<p-confirmDialog/>
